import React from "react";
import OrdersSubTabs from "../Order/OrdersSubTabs";
import "./EarningPlanHistory.css";

const EarningPlanHistory = () => (
  <>
    <div className="dashboard_right">
      <div className="dashboard_listing_section Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2">
          <div className="market_section spotorderhist">
            <div className="top_heading">
              <h4>Earning History</h4>
              <OrdersSubTabs
                tabs={[
                  { label: "Transactions", to: "/user_profile/orders/transaction_history" },
                  { label: "Deposit", to: "/user_profile/orders/deposit_history" },
                  { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
                  { label: "Transfer", to: "/user_profile/orders/transfer" },
                  { label: "Swap", to: "/user_profile/orders/swap_history" },
                  { label: "Wallet Transfer", to: "/user_profile/orders/wallet_transfer_History" },
                  { label: "Earning", to: "/user_profile/orders/earning_plan_history" },
                  { label: "Bonus", to: "/user_profile/orders/bonus_history" },
                ]}
              />
              <div className="coin_right">
                <div className="searchBar custom-tabs">
                  <i className="ri-search-2-line"></i>
                  <input
                    type="search"
                    className="custom_search"
                    placeholder="Search Crypto"
                    defaultValue=""
                  />
                </div>
              </div>
            </div>

            <div className="dashboard_summary earningplan">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Currency</th>
                    <th>Wallet</th>
                    <th>Duration</th>
                    <th>Start date</th>
                    <th>Mature date</th>
                    <th>Subscription Amount</th>
                    <th>Bonus Amount</th>
                    <th>Receivable Amount</th>
                    <th className="right_td">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>USDT</td>
                    <td className=" text-success">Spot Wallet</td>
                    <td>30</td>
                    <td>2026-01-01 </td>
                    <td>2026-01-31 </td>
                    <td>1000</td>
                    <td className=" text-success">+50</td>
                    <td>1050</td>
                    <td className="right_td text-success">COMPLETED</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>BTC</td>
                    <td className=" text-warning">Main Wallet</td>
                    <td>90</td>
                    <td>2026-02-01 </td>
                    <td>2026-05-02 </td>
                    <td>0.5</td>
                    <td className=" text-warning">+0.05</td>
                    <td>0.55</td>
                    <td className="right_td text-warning">ACTIVE</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>ETH</td>
                    <td className=" text-warning">Earning Wallet</td>
                    <td>14</td>
                    <td>2026-03-15 </td>
                    <td>2026-03-29 </td>
                    <td>2.5</td>
                    <td className=" text-warning">+0.125</td>
                    <td>2.625</td>
                    <td className="right_td text-warning">ACTIVE</td>
                  </tr>
                </tbody>
              </table>

              <div className="hVPalX gap-2">
                <span>1-3 of 3</span>
                <div className="sc-eAKtBH gVtWSU">
                  <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf">
                    <i className="ri-skip-back-fill text-white"></i>
                  </button>
                  <button type="button" aria-label="Previous Page" className="sc-gjLLEI kuPCgf">
                    <i className="ri-arrow-left-s-line text-white"></i>
                  </button>
                  <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf">
                    <i className="ri-arrow-right-s-line text-white"></i>
                  </button>
                  <button type="button" aria-label="Last Page" className="sc-gjLLEI kuPCgf">
                    <i className="ri-skip-forward-fill text-white"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="order_history_mobile_view">
          <div className="coin_right d-flex flex-row justify-content-between align-items-center p-0">
            <h5>Earning History</h5>
            <div className="d-flex flex-row justify-content-end align-items-end mb-3">
              <div className="searchBar custom-tabs">
                <i className="ri-search-2-line"></i>
                <input
                  type="search"
                  className="custom_search"
                  placeholder="Search Crypto"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <OrdersSubTabs
            tabs={[
              { label: "Transactions", to: "/user_profile/orders/transaction_history" },
              { label: "Deposit", to: "/user_profile/orders/deposit_history" },
              { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
              { label: "Transfer", to: "/user_profile/orders/transfer" },
              { label: "Swap", to: "/user_profile/orders/swap_history" },
              { label: "Wallet Transfer", to: "/user_profile/orders/wallet_transfer_History" },
              { label: "Earning", to: "/user_profile/orders/earning_plan_history" },
              { label: "Bonus", to: "/user_profile/orders/bonus_history" },
            ]}
          />
          <div className="d-flex">
            <div className="order_datalist">
              <ul className="listdata">
                <li>
                  <span className="date">Currency</span>
                  <span className="date_light">USDT</span>
                </li>
                <li>
                  <span>Wallet</span>
                  <span>Spot Wallet</span>
                </li>
                <li>
                  <span>Duration</span>
                  <span>30 days</span>
                </li>
                <li>
                  <span>Start Date</span>
                  <span>2026-01-01</span>
                </li>
                <li>
                  <span>Mature Date</span>
                  <span>2026-01-31</span>
                </li>
                <li>
                  <span>Subscription Amount</span>
                  <span>1000</span>
                </li>
                <li>
                  <span>Bonus Amount</span>
                  <span className="text-success">+50</span>
                </li>
                <li>
                  <span>Receivable Amount</span>
                  <span>1050</span>
                </li>
                <li>
                  <span>Status</span>
                  <span className="text-success">COMPLETED</span>
                </li>
              </ul>
            </div>

            <div className="order_datalist">
              <ul className="listdata">
                <li>
                  <span className="date">Currency</span>
                  <span className="date_light">BTC</span>
                </li>
                <li>
                  <span>Wallet</span>
                  <span>Main Wallet</span>
                </li>
                <li>
                  <span>Duration</span>
                  <span>90 days</span>
                </li>
                <li>
                  <span>Start Date</span>
                  <span>2026-02-01</span>
                </li>
                <li>
                  <span>Mature Date</span>
                  <span>2026-05-02</span>
                </li>
                <li>
                  <span>Subscription Amount</span>
                  <span>0.5</span>
                </li>
                <li>
                  <span>Bonus Amount</span>
                  <span className="text-warning">+0.05</span>
                </li>
                <li>
                  <span>Receivable Amount</span>
                  <span>0.55</span>
                </li>
                <li>
                  <span>Status</span>
                  <span className="text-warning">ACTIVE</span>
                </li>
              </ul>
            </div>

            <div className="order_datalist">
              <ul className="listdata">
                <li>
                  <span className="date">Currency</span>
                  <span className="date_light">ETH</span>
                </li>
                <li>
                  <span>Wallet</span>
                  <span>Earning Wallet</span>
                </li>
                <li>
                  <span>Duration</span>
                  <span>14 days</span>
                </li>
                <li>
                  <span>Start Date</span>
                  <span>2026-03-15</span>
                </li>
                <li>
                  <span>Mature Date</span>
                  <span>2026-03-29</span>
                </li>
                <li>
                  <span>Subscription Amount</span>
                  <span>2.5</span>
                </li>
                <li>
                  <span>Bonus Amount</span>
                  <span className="text-warning">+0.125</span>
                </li>
                <li>
                  <span>Receivable Amount</span>
                  <span>2.625</span>
                </li>
                <li>
                  <span>Status</span>
                  <span className="text-warning">ACTIVE</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="hVPalX gap-2 mt-3">
            <span>1-3 of 3</span>
            <div className="sc-eAKtBH gVtWSU">
              <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-skip-back-fill text-white"></i>
              </button>
              <button type="button" aria-label="Previous Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-arrow-left-s-line text-white"></i>
              </button>
              <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-arrow-right-s-line text-white"></i>
              </button>
              <button type="button" aria-label="Last Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-skip-forward-fill text-white"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default EarningPlanHistory;
